import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Target, Eye, Rocket, Shield } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

const VALUES = [
  { icon: Target, title: "Discipline over dopamine", desc: "We reward consistent effort, not endless scrolling." },
  { icon: Eye, title: "Status you can earn", desc: "Rank reflects real progress — verified and visible." },
  { icon: Rocket, title: "Built to compete", desc: "PvP battles and leaderboards keep you accountable." },
  { icon: Shield, title: "Privacy-first", desc: "Your data powers your growth, never sold to advertisers." },
];

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24 min-h-screen relative">
      <Seo title="About — ASCENDXP" description="ASCENDXP is a gamified self-improvement platform that turns discipline into status." />
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-indigo-600/10 blur-[120px]" />
      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-indigo-400 font-bold mb-4">Our Mission</p>
          <h1 className="font-heading font-black text-4xl sm:text-6xl tracking-tighter leading-[1]">
            We turn discipline into <span className="text-gradient-gold">status</span>
          </h1>
          <p className="mt-6 text-lg text-zinc-400 leading-relaxed">
            ASCENDXP was born from a simple frustration: the apps we use most reward vanity, not
            growth. We built a different kind of platform — one where the grind is the flex.
            Every habit, every streak, every won battle raises your Aura and your rank.
          </p>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            With AI coaching, PvP arenas, clans, and deep analytics, ASCENDXP makes self-improvement
            feel like the most competitive game you've ever played — because it should be.
          </p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 gap-6">
          {VALUES.map((v, i) => {
            const Icon = v.icon;
            return (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="glass rounded-2xl p-7 h-full">
                  <div className="w-11 h-11 rounded-xl bg-indigo-600/15 text-indigo-400 grid place-items-center mb-4">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-heading font-bold text-lg mb-2">{v.title}</h3>
                  <p className="text-sm text-zinc-400">{v.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 glass rounded-3xl p-10 text-center glow-indigo">
            <h2 className="font-heading font-bold text-2xl sm:text-3xl">Ready to ascend?</h2>
            <div className="mt-6 flex flex-wrap gap-4 justify-center">
              <a href="#" className="btn-gold">Download App</a>
              <Link to="/pricing" className="btn-primary">View Plans</Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
